import { PathBase } from "@constellation-academy/epic-ui";

export class LimitedCartDiscountEditPath extends PathBase {
	static readonly pathKey = "edit";
}
